export type SOPPaymentSummaryTypes = {
  paymentMethodProvider: string;
  profileId: string;
  paymentId: string;
  cardId: string;
};

export enum paymentMethodProviderIdEnum {
  ODD = 'odd',
}
